import React from 'react'
import Header from '../_components/common/Header'
import OverviewUI from '../_components/UI/OverviewUI'

const Overview = () => {
  return (
    <div className='page-main'>
        <Header name= {['Overview'] }/>
        <OverviewUI/>
       
    </div>
  )
}

export default Overview